// Универсальные функции валидации

// Валидация email
export const isValidEmail = (email: string): boolean => {
  if (!email || email.trim() === '') return true; // Пустое поле допустимо
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email.trim());
};

// Валидация телефона (международный формат)
export const isValidPhone = (phone: string): boolean => {
  if (!phone || phone.trim() === '') return true; // Пустое поле допустимо
  // Удаляем все кроме цифр и +
  const cleaned = phone.replace(/[\s()\-]/g, '');
  // Минимум 10 цифр, может начинаться с +
  const phoneRegex = /^\+?[0-9]{10,15}$/;
  return phoneRegex.test(cleaned);
};

// Валидация URL
export const isValidUrl = (url: string): boolean => {
  if (!url || url.trim() === '') return true; // Пустое поле допустимо
  try {
    const urlObj = new URL(url.trim());
    return urlObj.protocol === 'http:' || urlObj.protocol === 'https:';
  } catch {
    return false;
  }
};

// Форматирование телефона при вводе (из RegisterPage)
export const formatPhoneNumber = (value: string): string => {
  // Удаляем все нецифровые символы для анализа
  const digits = value.replace(/\D/g, '');

  // Определяем, использовать ли формат +1 или обычный формат
  if (value.startsWith('+1')) {
    // Американский формат: +1 (XXX) XXX-XXXX
    if (digits.length <= 1) return '+1 ';
    if (digits.length <= 4) return `+1 (${digits.slice(1)}`;
    if (digits.length <= 7) return `+1 (${digits.slice(1, 4)}) ${digits.slice(4)}`;
    return `+1 (${digits.slice(1, 4)}) ${digits.slice(4, 7)}-${digits.slice(7, 11)}`;
  } else if (value.startsWith('+')) {
    // Другие международные форматы - просто добавляем пробелы
    return value;
  } else {
    // Обычный формат: (XXX) XXX-XXXX
    if (digits.length === 0) return '';
    if (digits.length <= 3) return `(${digits}`;
    if (digits.length <= 6) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
    return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6, 10)}`;
  }
};

// Очистка телефона для отправки на сервер
export const cleanPhoneNumber = (phone: string): string => {
  return phone.replace(/\D/g, '');
};

// Сообщения об ошибках
export const ValidationMessages = {
  invalidEmail: 'Invalid email format',
  invalidPhone: 'Invalid phone number (min 10 digits)',
  invalidUrl: 'Invalid URL (must start with http:// or https://)'
};
